import React from 'react';
import { Check } from 'lucide-react';
import { useLang } from '../i18n/LangContext';
import Reveal from './Reveal';

export default function WhyAlpha7() {
  const { t } = useLang();
  const stats = t('why.stats');
  const points = t('why.points');

  return (
    <section id="why" data-testid="why-section" className="relative py-24 md:py-40 border-t border-[#27272A]">
      <div className="max-w-[1440px] mx-auto px-6 md:px-12">
        <Reveal className="section-index">{t('why.index')}</Reveal>
        <Reveal as="h2" className="h-section text-[#F5F5F2] mt-4 max-w-3xl reveal-delay-1">
          {t('why.title')}
        </Reveal>

        {/* Stats */}
        <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-px bg-[#27272A] border border-[#27272A]">
          {stats.map((s, i) => (
            <Reveal key={i} className={`reveal-delay-${(i % 4) + 1}`}>
              <div data-testid={`stat-${i}`} className="bg-[#0F0F11] p-6 md:p-8 h-full flex flex-col">
                <span className="font-mono text-[10px] tracking-[0.3em] text-[#C8102E]">{String(i + 1).padStart(2, '0')}</span>
                <span className="stat-number mt-5">{s.num}</span>
                <span className="mt-4 text-sm text-[#A1A1AA] leading-relaxed">{s.label}</span>
              </div>
            </Reveal>
          ))}
        </div>

        {/* Points */}
        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-6 max-w-5xl">
          {points.map((p, i) => (
            <Reveal key={i} className={`flex gap-4 reveal-delay-${(i % 4) + 1}`}>
              <div className="mt-1 w-6 h-6 border border-[#C8102E] flex items-center justify-center shrink-0">
                <Check size={12} className="text-[#C8102E]" />
              </div>
              <p className="text-base text-[#F5F5F2]/90 leading-relaxed">{p}</p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
